import { Alert, Modal, Select } from 'antd-v5';
import React, { useCallback, useState } from 'react';

export const AssignAssociatesModal = ({ isOpen, onClose, onAssign, allAssoc, warning }) => {
  const [selectedAssociate, setSelectedAssociate] = useState(null);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);

  const handleClose = useCallback(
    e => {
      e?.stopPropagation();
      setSelectedAssociate(null);
      setSearch('');
      onClose();
    },
    [onClose],
  );

  const handleSave = useCallback(async () => {
    setLoading(true);
    if (!selectedAssociate) {
      setLoading(false);
      return;
    }
    await onAssign(selectedAssociate);
    setLoading(false);
    handleClose();
  }, [selectedAssociate, onAssign, handleClose]);

  return (
    <Modal
      title="Assign Associate"
      open={isOpen}
      onCancel={handleClose}
      onOk={handleSave}
      okText="Assign"
      cancelText="Cancel"
      width={400}
      centered
      destroyOnClose
      confirmLoading={loading}
      okButtonProps={{ disabled: !selectedAssociate }}
    >
      <Select
        placeholder="Select Associate"
        onChange={value => setSelectedAssociate(value)}
        options={allAssoc.map(assoc => ({
          value: assoc.id,
          label: `${assoc?.first_name || ''} ${assoc?.last_name || ''}`,
        }))}
        style={{
          width: '100%',
          marginTop: 12,
          marginBottom: 12,
        }}
        showSearch
        searchValue={search}
        onSearch={setSearch}
        filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
      />
      {warning && <Alert message={warning} type="warning" showIcon />}
    </Modal>
  );
};
